var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68975 3.6416C7.81738 3.6416 7.93979 3.6923 8.03004 3.78256C8.12029 3.87281 8.171 3.99522 8.171 4.12285V5.30993L9.27466 5.0892C10.3339 4.87727 11.4319 4.97804 12.4349 5.37923L12.6999 5.48511C13.6142 5.85082 14.6205 5.91907 15.5758 5.68018C15.6657 5.65769 15.7603 5.66236 15.8475 5.69362C15.9347 5.72487 16.0108 5.7813 16.0659 5.85576C16.1211 5.93023 16.1529 6.01938 16.1574 6.11193C16.1619 6.20449 16.1388 6.2963 16.0911 6.37574L15.271 7.74313C15.0516 8.10888 14.9419 8.29112 14.9162 8.48939C14.9053 8.57281 14.9053 8.65623 14.9162 8.73964C14.9419 8.93792 15.0516 9.12079 15.271 9.4859L16.272 11.1542C16.3184 11.2316 16.3461 11.3187 16.3527 11.4087C16.3594 11.4986 16.3449 11.5889 16.3104 11.6722C16.2759 11.7555 16.2224 11.8296 16.1541 11.8885C16.0858 11.9475 16.0047 11.9896 15.9172 12.0115L15.853 12.0275C14.7176 12.3115 13.5216 12.2305 12.4349 11.7959C11.4321 11.3948 10.3343 11.294 9.2753 11.5059L8.171 11.7266V16.9562C8.171 17.0838 8.12029 17.2062 8.03004 17.2965C7.93979 17.3867 7.81738 17.4374 7.68975 17.4374C7.56211 17.4374 7.4397 17.3867 7.34945 17.2965C7.2592 17.2062 7.2085 17.0838 7.2085 16.9562V4.12285C7.2085 3.99522 7.2592 3.87281 7.34945 3.78256C7.4397 3.6923 7.56211 3.6416 7.68975 3.6416Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAction);
export default __webpack_public_path__ + "static/media/flagAction.7962a3673f81262fa8c5ee913e309eb0.svg";
export { ForwardRef as ReactComponent };